import React, { useState } from "react";
import "./ProfileSettings.css";  
import eyeIcon from "../../../Assets/icons/eye-icon.svg";  
import eyeIconOpen from "../../../Assets/icons/eye-icon-open.svg";  
import ConfirmEmail from "./ConfirmEmail"; 
import Service from "../../../API/Service";

const ChangePassword = ({ setIsChangePassword }) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isMatching, setIsMatching] = useState(true);
    const [isValid, setIsValid] = useState(null);
    const [step, setStep] = useState("changePassword");
    const [errorMessage, setErrorMessage] = useState("");

    const validatePassword = (password) => {
        return (
            /[A-Z]/.test(password) &&        
            /[a-z]/.test(password) &&        
            /[0-9]/.test(password) &&        
            /[!@#$%^&*]/.test(password) &&   
            password.length >= 8             
        );
    };

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setIsValid(validatePassword(newPassword)); // Проверка валидности при вводе
        setIsMatching(newPassword === confirmPassword); // Проверка совпадения паролей
    };

    const handleConfirmPasswordChange = (e) => {
        const newConfirmPassword = e.target.value;
        setConfirmPassword(newConfirmPassword);
        setIsMatching(password === newConfirmPassword); // Проверка совпадения при вводе
    };

    const handleSave = async () => {
        if (!isValid) {
            setErrorMessage("Password does not meet requirements.");
            return;
        }

        if (!isMatching) {
            setErrorMessage("Passwords do not match.");
            return;
        }

        setErrorMessage("");

        try {
            const personalData = await Service.getPersonalData();
            await Service.sendOtp(personalData.login); 
            setStep("confirmEmail"); 
        } catch (error) {
            console.error("Ошибка отправки OTP:", error);
            alert("Ошибка при отправке кода.");
        }
    };

    return step === "changePassword" ? (
        <div className="changePasswordContainer">
            <h2 className="changePasswordTitle">Change Password</h2>

            <div className="passwordForm">
                <div className="field">
                    <p>New password</p>
                    <div className="passwordInput">
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter new password"
                            value={password}
                            onChange={handlePasswordChange}
                            className="passwordField"
                        />
                        <img
                            src={showPassword ? eyeIconOpen : eyeIcon}
                            alt="Toggle Password"
                            className="eye-icon"
                            onClick={() => setShowPassword(!showPassword)}
                        />
                    </div>
                </div>

                <div className="field">
                    <p>Type new password again</p>
                    <div className="passwordInput">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            className="passwordField"
                            style={{ borderColor: isMatching ? "" : "#EF4444" }}
                        />
                        <img
                            src={showConfirmPassword ? eyeIconOpen : eyeIcon}
                            alt="Toggle Confirm Password"
                            className="eye-icon"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        />
                    </div>
                </div>

                {errorMessage && <p className="errorText">{errorMessage}</p>} 

                <div className={`passwordInstructions ${isValid ? "valid" : "invalid"}`}>
                    <ul>
                        <li style={{ color: /[A-Z]/.test(password) ? "green" : "red" }}>
                            At least one uppercase (A-Z)
                        </li>
                        <li style={{ color: /[a-z]/.test(password) ? "green" : "red" }}>
                            At least one lowercase (a-z)
                        </li>
                        <li style={{ color: /[0-9]/.test(password) ? "green" : "red" }}>
                            At least one number (0-9)
                        </li>
                        <li style={{ color: /[!@#$%^&*]/.test(password) ? "green" : "red" }}>
                            At least one special character (@, #, $, etc.)
                        </li>
                        <li style={{ color: password.length >= 8 ? "green" : "red" }}>
                            At least 8-12 characters long
                        </li>
                    </ul>
                </div>
            </div>

            <div className="buttonGroup">
                <button className="saveButton" onClick={handleSave}>Save Changes</button>
                <button className="cancelButton" onClick={() => setIsChangePassword(false)}>Cancel</button>
            </div>
        </div>
    ) : (
        <ConfirmEmail newPassword={password} />
    );
};

export default ChangePassword;
